import { AggregateScoreType } from "~/operations";
import { CheckCell, CheckCellProps } from "./CheckCell";
import { VulnerabilityCell, VulnerabilityCellProps } from "./VulnerabilityCell";
import { AdvisoryCell, AdvisoryCellProps } from "./AdvisoryCell";
import { SoftwareCell } from "./SoftwareCell";

export type AllSecurityFindingCellProps = {
  type: AggregateScoreType;
  CheckCellProps: CheckCellProps;
  VulnerabilityCellProps: VulnerabilityCellProps;
  AdvisoryCellProps: AdvisoryCellProps;
};

export function AllSecurityFindingCell({
  type,
  CheckCellProps,
  VulnerabilityCellProps,
  AdvisoryCellProps,
}: AllSecurityFindingCellProps) {
  switch (type) {
    case AggregateScoreType.Check:
      return <CheckCell {...CheckCellProps} />;
    case AggregateScoreType.Advisory:
      return <AdvisoryCell {...AdvisoryCellProps} />;
    case AggregateScoreType.Vulnerability:
      return <VulnerabilityCell {...VulnerabilityCellProps} />;
    case AggregateScoreType.VersionedSoftware:
    case AggregateScoreType.Software:
      return (
        <SoftwareCell
          row={CheckCellProps.row}
          size={CheckCellProps.isSmallTable ? "small" : undefined}
        />
      );
    default:
      return <></>;
  }
}
